import { Component, OnInit } from '@angular/core';
import {FeaturedProductsService} from '../../../services/featured-products.service';
import {FeaturedProductIconConfig} from '../../../models/featured-product';

@Component({
  selector: 'app-featured-product-icon-group',
  templateUrl: './featured-product-icon-group.component.html'
})
export class FeaturedProductIconGroupComponent implements OnInit {

  products: FeaturedProductIconConfig[];

  constructor(private featuredProductsService: FeaturedProductsService) { }

  ngOnInit(): void {
    this.products = this.featuredProductsService.featuredProductIcons;
  }

}
